var React = require('react');

function Pdf (props) {
    return React.createElement("svg",props,React.createElement("g",{"stroke":"#5147DC","strokeWidth":"1.5","fill":"none","fillRule":"evenodd"},[React.createElement("path",{"d":"M12 6.767v8.004H1v-14h5.017","key":0}),React.createElement("path",{"d":"M7.75.804v4.245h4.186L7.75.804zM3.5 5.771H6M3.5 8.078h6.2M3.5 10.543h6.2","key":1})]));
}

Pdf.displayName = "Pdf";

Pdf.defaultProps = {"width":"13","height":"16"};

module.exports = Pdf;

Pdf.default = Pdf;
